import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { queryParams } from "../../../helpers/UrlHelpers";
import { fetchUsers } from "../../../actions/roblox/usersActions";

import PageLayout from '../_partials/PageLayout';
import List from "./_partials/_List";
import PageHeader from "../../../componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";

const LIMIT = 42;

const Users = () => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const { pathname }    = useLocation();

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT,
        show_addons: true
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    dispatch(fetchUsers(params));
  }, [searchParams, pathname, currentPage, dispatch]);

  return (
    <PageLayout className='v-users'>
      <PageHeader title='Users' />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            orderBy={{
              items: [
                { name: 'Register', key: 'id' },
                { name: 'Seen', key: 'launch_at' }
              ]
            }}
          />
        </Wrapper>

        <List limit={LIMIT} />
      </div>
    </PageLayout>
  );
}

export default Users;
